import { SVGProps } from "react";

const SIContainerd = (props: SVGProps<SVGSVGElement>) => <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}><title>{"containerd"}</title><path d="M3.629 0v24H20.37V0zM17.59 21.208H6.421V10.604h7.812V6.692h3.346v14.516zm-7.823-7.812h4.466v5.02H9.767z" /></svg>;

export { SIContainerd };